import {ThemeTypeEnum} from "services/theme/data"
import create from "zustand"
import {persist} from "zustand/middleware"

const THEME_STORAGE_KEY = "theme"

/**
 * @typedef {Object} ThemeState
 * @property {import("services/theme/data").AppStoreTheme} theme
 * @property {function(import("services/theme/data").AppStoreTheme): void} setTheme
 */

/** @type {import("zustand").UseBoundStore<import("zustand").StoreApi<ThemeState>>} */
const useThemeStore = create(
  persist(
    set => ({
      theme: "",
      setTheme: theme =>
        set(() => {
          return {theme}
        }),
    }),
    {
      name: THEME_STORAGE_KEY,
      getStorage: () => sessionStorage,
    },
  ),
)

export const getStoreTheme = () => useThemeStore.getState().theme

export const setStoreTheme = useThemeStore.getState().setTheme

/**
 * Returns the current theme value.
 * If the `theme` is an empty string, it defaults to `ThemeTypeEnum.enum.light`.
 */
export const useThemeValue = () => {
  const theme = useThemeStore(state => state.theme)

  /**
   * The `theme` will be an empty string when a user opens a new tab and
   * the system preference has not yet been successfully updated to the store.
   */
  return theme === "" ? ThemeTypeEnum.enum.light : theme
}
